import $ from 'jquery';
import 'slick-carousel';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
var initializeBlock = function ($block) {
  var $carousel = $block.find('[data-block-carousel]');
  var autoplay = $carousel.attr('data-autoplay');
  var speed = $carousel.attr('data-autoplay-speed');
  $carousel.slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: false,
    focusOnSelect: true,
    adaptiveHeight: false,
    arrows: true,
    appendDots: '#sliderControls',
    prevArrow: '',
    appendArrows: '#sliderControls',
    autoplay: !!autoplay,
    autoplaySpeed: speed ? parseInt(speed, 10) : 8000,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
        },
      },
    ],
  });
  $(document).resize();
};

// Initialize each block on page load (front end).
$(document).ready(function () {
  $('.block-carousel').each(function () {
    var $carousel = $(this);
    initializeBlock($(this));

    $(this)
      .find('.campaign-slider__toggle-play')
      .click(function () {
        toggleAutoplay($carousel, $(this));
      });
  });
});

function toggleAutoplay($carousel, $button) {
  const turnAutoplayOn = $button.hasClass('paused');
  if (!turnAutoplayOn) {
    $button.addClass('paused');
    $button.find('span').text('Play carousel');
  } else {
    $button.removeClass('paused');
    $button.find('span').text('Pause carousel');
  }
  $carousel
    .find('[data-block-carousel]')
    .slick('slickSetOption', 'autoplay', turnAutoplayOn, true);
}

// Initialize dynamic block preview (editor).
if (window.acf) {
  window.acf.addAction('render_block_preview/type=carousel', initializeBlock);
}
